import React from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import translate from '../../../../commonComponents/translate';
import CheckIcon from '../../../../commonComponents/icons/CheckIcon';
import LockIcon from '../../../../commonComponents/icons/LockIcon';
import ProgressIcon from './ProgressIcon';

const LevelCard = props => {
  const { t, index, levelData } = props;

  const { level, skillLevel, directActive, personalVA, levelRequirements } =
    levelData;

  const isLevelComplete = cardIndex => {
    if (cardIndex === 0) {
      return level > 0;
    }
    return false;
  };

  const isStageComplete = stageObject => {
    if (stageObject?.limitAchieved) {
      return (
        <div className="completedStageCheck">
          <CheckIcon color="#3FBC5F" />
        </div>
      );
    }
    return (
      <div className="progress-icon-cell">
        <ProgressIcon data={stageObject} />
      </div>
    );
  };
  const daysLeft = () => {
    const endOfMonth = moment().endOf('month');

    return endOfMonth.diff(moment(), 'days');
  };

  const levelProgress = () => {
    const daysInMonth = moment().daysInMonth();

    return (moment().format('DD') * 100) / daysInMonth;
  };

  return (
    <div className={`level-card card-${index + 1}`}>
      {isLevelComplete(index) && (
        <div className="cardBookmark">
          <span className="cardBookmarkText">
            {t('report.arcova.levelCompleted')}
            <img
              src="/images/reports/party-hat.svg"
              alt="yay"
              className="partyHat"
            />
          </span>
        </div>
      )}
      <div className="cardHeader">
        {index === 2 && (
          <div className="cardLockContainer">
            <LockIcon width={76} height={96} />
          </div>
        )}
        <span className="levelLabel">
          {t('report.arcova.level')} {level}
        </span>
        <img
          src={skillLevel.icon}
          alt={skillLevel.name}
          className="level-card-image"
        />
        {isLevelComplete(index) && (
          <div className="completedLevelCheck">
            <CheckIcon />
          </div>
        )}
        <span className="levelLabelName">{skillLevel.name}</span>
        {index === 1 && (
          <div className="progress">
            <div
              className="progress-bar"
              role="progressbar"
              style={{
                width: `${levelProgress()}%`,
              }}
            >
              {daysLeft()} {t('report.arcova.daysLeft')}
            </div>
          </div>
        )}
      </div>
      <div className="cardTableBody">
        <table className="table" style={{ width: '100%' }}>
          <tbody>
            <tr className="content" key="row-1">
              <td className="contentCell">
                <div className="completedStageCheck">
                  {directActive && directActive.limitAchieved ? (
                    <CheckIcon color="#3FBC5F" />
                  ) : (
                    <></>
                  )}
                </div>
                <span className="contentCellText">
                  {directActive && directActive.limit}
                </span>
              </td>
            </tr>
            <tr className="content" key="row-2">
              <td className="contentCell">
                {isStageComplete(personalVA)}
                <span className="contentCellText">
                  {personalVA && personalVA.limit}
                </span>
              </td>
            </tr>
            <tr className="content" key="row-3">
              <td
                className="contentCell"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '1rem',
                }}
              >
                {levelRequirements.length > 0 ? (
                  levelRequirements.map(goal => (
                    <div style={{ display: 'flex' }} key={goal.level}>
                      <div className="completedStageCheck">
                        {goal.limitAchieved && <CheckIcon color="#3FBC5F" />}
                      </div>
                      <span className="contentCellText">
                        &gt;=&nbsp;
                        {t(
                          'report.objectives.atLeastLevel',
                          goal.amount,
                          goal.level,
                        )}
                      </span>
                    </div>
                  ))
                ) : (
                  <div style={{ display: 'flex' }}>
                    <div className="completedStageCheck">
                      <CheckIcon color="#3FBC5F" />
                    </div>
                    <span className="contentCellText">{t('none')}</span>
                  </div>
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

LevelCard.propTypes = {
  t: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  levelData: PropTypes.shape({
    level: PropTypes.number.isRequired,
    levelCompleted: PropTypes.bool.isRequired,
    numDaysLeft: PropTypes.number,
    skillLevel: PropTypes.shape({
      icon: PropTypes.string,
      name: PropTypes.string,
    }).isRequired,
    directActive: PropTypes.shape({
      limit: PropTypes.number,
      limitAchieved: PropTypes.bool,
      currentValue: PropTypes.number,
    }).isRequired,
    groupVA: PropTypes.shape({
      limit: PropTypes.number,
      limitAchieved: PropTypes.bool,
      currentValue: PropTypes.number,
    }).isRequired,
    personalVA: PropTypes.shape({
      limit: PropTypes.number,
      limitAchieved: PropTypes.bool,
      currentValue: PropTypes.number,
    }).isRequired,
    levelRequirements: PropTypes.arrayOf(
      PropTypes.shape({
        amount: PropTypes.number,
        level: PropTypes.number,
        limitAchieved: PropTypes.number,
      }),
    ),
  }).isRequired,
};

export default translate(LevelCard);
